import styled from 'styled-components';
import { NuvoToast } from '@nuvolo/nuux-core/components/NuvoToast';

const StyledNuvoToast = styled(NuvoToast)`
  display: none;

  div[style='display: contents;'] > .custom-toast-message {
    display: none;
  }
`;

export default StyledNuvoToast;
